// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"63":"03e85c9e","571":"84213b91","660":"a3bb58d4"}[chunkId] + ".bundle.js";
};